// DS: MO 4.1.7
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import BoostIcon from '@wix/da-ds/pkg/Icons/16x16/BoostFilled';
import DeviationPromo from '../DeviationPromo';
import BoostRootModal from '../../../../ActionBar/buttons/BoostButton/modals/BoostRootModal';
import { BiContextProvidedValue, BiData, GiveBadgeAwardBiEvent } from '@wix/da-bi/pkg/events';
import { ResourceType } from '../../../../types/resource';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';

interface Props {
  deviation: PapiDeviation;
}

const BoostPromo: React.FC<Props> = ({ deviation }) => {
  const { t } = useTranslation();
  const [isShowingModal, setShowingModal] = useState<boolean>(false);

  const openBoostModal = () => setShowingModal(true);
  const closeBoostModal = () => setShowingModal(false);

  return (
    <BiLoggerContextProvider
      key={deviation.deviationId}
      value={{
        sectionname: 'boost_promotion',
      }}
    >
      <DeviationPromo
        deviation={deviation}
        onClick={openBoostModal}
        heading={t('sidebar.boostPromo.heading')}
        subheading={t('sidebar.boostPromo.description')}
        attributionSlot={deviation && t('sidebar.boostPromo.attribution')}
        ctaSlot={
          <SolidButton
            size="medium"
            icon={BoostIcon}
            variant="main"
            fillContainerWidth
            onClick={openBoostModal}
            isFakeButton
            biData={BiData<GiveBadgeAwardBiEvent>({
              evid: 320,
              sectionname: BiContextProvidedValue,
              itemid: deviation.deviationId,
              typeid: ResourceType.TIER,
              badge_type: 'boost',
              badge_typeid: 176,
            })}
          >
            {t('sidebar.boostPromo.sellCta')}
          </SolidButton>
        }
      />
      {isShowingModal && <BoostRootModal deviation={deviation} onRequestClose={closeBoostModal} />}
    </BiLoggerContextProvider>
  );
};

BoostPromo.displayName = 'BoostPromo';

export default BoostPromo;
